/// <reference path="../../_ext/Bases/ItemDialog.ts" />
namespace TabAurous.Common {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    @Serenity.Decorators.maximizable()
    @Serenity.Decorators.responsive()
    export class ProductEnquiryDialog extends _Ext.ItemDialog<OMS.ProductMasterRow, any> {
        type: string;
        protected getFormKey() { return Common.ProductEnquiryForm.formKey; }
        protected getLocalTextPrefix() { return OMS.ProductMasterRow.localTextPrefix; }
        protected getNameProperty() { return OMS.ProductMasterRow.nameProperty; }
        protected useViewMode() { return true; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.PendingChangesConfirmation = false;
            return opt;
        }
        protected form = new Common.ProductEnquiryForm(this.idPrefix);
        Markup: number = 0;

        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.LaborDetails);
            q.hideImageToolbar(this.form.ImageName);
            q.hideEditorLabel(this.form.ImageName);
            q.hideImageToolbar(this.form.Image1);
            q.hideEditorLabel(this.form.Image1);
            q.hideImageToolbar(this.form.Image2);
            q.hideEditorLabel(this.form.Image2);
            q.hideImageToolbar(this.form.Image3);
            q.hideEditorLabel(this.form.Image3);
            //q.hideImageToolbar(this.form.ImageName);
            //q.hideImageToolbar(this.form.Image1);
            //q.hideImageToolbar(this.form.Image2);
            //q.hideImageToolbar(this.form.Image3); 

            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Rate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.TaxAmount);
            q.setTextRightAlign(this.form.TotalAmount);
            q.setTextRightAlign(this.form.UnitLabour);
            q.setTextRightAlign(this.form.MFAmount);
            q.setTextRightAlign(this.form.DiamondDiscountPercent);
            q.SetCategorySixColumn(this.form.ProductCode);
            q.SetCategorySixColumn(this.form.Image1);
            q.SetSix12Column(this.form.BOMDetails);
            q.SetSix12Column(this.form.LaborDetails);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.DiamondPieces);
            q.SetCategoryFullWidth(this.form.Remarks);

            q.HideOnlyDialogToolbar(this.element);
            q.HideCategoryLable(this.element);
            this.dialogTitle = "Product Enquiry";


            let hideattributes = q.ToBool(TabAurous.GetConfigValue(1044));
            if (hideattributes == true) {
                q.hideField(this.form.ProductName);
                q.hideField(this.form.ItemTypeId);
                q.hideField(this.form.CategoryId);
                q.hideField(this.form.SubCategoryId);
                q.hideField(this.form.BrandId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);
                q.hideField(this.form.MetalColorId);
                q.hideField(this.form.MetalId);
                q.hideField(this.form.KaratId);
                q.hideField(this.form.ProductSizeId);
            } else if (hideattributes == false) {
                q.showAndDisableField(this.form.ProductName);
                q.showAndDisableField(this.form.ItemTypeId);
                q.showAndDisableField(this.form.CategoryId);
                q.showAndDisableField(this.form.SubCategoryId);
                q.showAndDisableField(this.form.BrandId);
                q.showAndDisableField(this.form.CollectionId);
                q.showAndDisableField(this.form.SuperTypeId);
                q.showAndDisableField(this.form.MetalColorId);
                q.showAndDisableField(this.form.MetalId);
                q.showAndDisableField(this.form.KaratId);
                q.showAndDisableField(this.form.ProductSizeId);
            }
            let hideaadditionalimages = q.ToBool(TabAurous.GetConfigValue(1045));
            if (hideaadditionalimages == true) {
                q.hideField(this.form.Image1);
                q.hideField(this.form.Image2);
                q.hideField(this.form.Image3);
            } else if (hideaadditionalimages == false) {
                q.showAndDisableField(this.form.Image1);
                q.showAndDisableField(this.form.Image2);
                q.showAndDisableField(this.form.Image3);
            }
            this.form.ProductEnquiryType.changeSelect2(e => {
                var type = this.form.ProductEnquiryType.value;
                if (type == "SKU") {
                    q.showAndDisableField(this.form.ProductCode);
                    q.showAndEnableField(this.form.SearchSKU);
                }
                else {
                    q.showAndEnableField(this.form.ProductCode);
                    q.showAndDisableField(this.form.SearchSKU);
                }

            });
            this.form.ProductCode.changeSelect2(e => {

                let searchinstock = q.ToBool(TabAurous.GetConfigValue(1042));
                if (searchinstock) {
                    if (!Q.isEmptyOrNull(this.form.ProductCode.value)) {
                        var type = this.form.ProductEnquiryType.value;
                        //this.setData(type, this.form.ProductCode.value);
                        let product;
                        var _product = [];
                        var productcode = this.form.ProductCode.value.toUpperCase();
                        Stock.StockEnquiryService.List({ ProductCode: productcode },
                            response => {
                                if (response.Entities.length > 0) {
                                    let entity: Stock.StockItemRow;
                                    if (response.Entities.length > 1) {
                                        var self = this;
                                        var grid = Common.ProductEnquirySelectGrid;
                                        var options: _Ext.SelectGridFilters = {
                                            Items: response.Entities,
                                            ProductCode: productcode
                                        }
                                        var pickerDialog = new _Ext.GridItemPickerDialog({
                                            gridType: grid, multiple: false, title: "Select Product", GridFilters: options
                                        });


                                        pickerDialog.onSuccess = (selectedItems: Stock.StockItemRow[]) => {
                                            if (selectedItems.length > 0) {
                                                product = selectedItems[0];

                                                var _prd = [];
                                                _prd.push(product);
                                                self.RecalculateMF(_prd);

                                            }
                                        }


                                        pickerDialog.dialogOpen();
                                    }
                                    else
                                        product = response.Entities[0];
                                    if (product != null) {
                                        _product.push(product);
                                        this.RecalculateMF(_product);
                                    }
                                }
                                else {
                                    //to get data from Product Master
                                    //if (productid == 0) {
                                    //    OMS.ProductMasterService.ProductEnquiry({ ProductCode: productcode },
                                    //        response => {
                                    //            if (response.Entity != undefined) {
                                    //                var entity = response.Entity;
                                    //                productid = entity.ProductId;
                                    //                this.form.ProductName.value = entity.ProductName;
                                    //                this.form.ProductTypeName.value = entity.ProductTypeName;
                                    //                this.form.BrandName.value = entity.BrandName;
                                    //                this.form.SuperTypeName.value = entity.SuperTypeName;
                                    //                this.form.CollectionName.value = entity.CollectionName;
                                    //                this.form.CategoryName.value = entity.CategoryName;
                                    //                this.form.SubCategoryName.value = entity.SubCategoryName;
                                    //                //this.form.KaratName.value = entity.KaratName;
                                    //                this.form.MetalName.value = entity.MetalName;
                                    //                this.form.Line_No.value = "";
                                    //                //this.form.TaxCode.value = entity.TaxCode;
                                    //                //this.form.DeptName.value = entity.DeptName;
                                    //                this.form.Pieces.value = entity.Pieces;
                                    //                this.form.Weight.value = entity.Weight;
                                    //                if (entity.ItemTypeId != 101)
                                    //                    this.setProductvalues(entity);
                                    //                else
                                    //                    q.hideEditorTab(this.form.BOMDetails, false);

                                    //                if (entity.BOMDetails.length > 0) {
                                    //                    var bomdetails = entity.BOMDetails;
                                    //                    this.form.BOMDetails.setdata(bomdetails);
                                    //                    this.form.BOMDetails.setselectedrow();
                                    //                    this.setbomvalues(bomdetails[0]);
                                    //                }
                                    //                OMS.ProductMasterService.GetProductImages({ ProductId: entity.ProductId },
                                    //                    response => {
                                    //                        if (response.Entities.length > 0)
                                    //                            this.setProductImages(response.Entities[0]);
                                    //                    }, { async: false })
                                    //            }
                                    //        }, { async: false });
                                    //}
                                }
                            }, { async: false });


                    }
                }
                else {

                    var type = this.form.ProductEnquiryType.value;
                    this.setData(type, this.form.ProductCode.value);
                }

            });
            this.form.SearchSKU.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.SearchSKU.value)) {
                    var type = this.form.ProductEnquiryType.value;
                    this.setData(type, this.form.SearchSKU.value);
                }
            });



            this.form.SearchSKU.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.SearchSKU.value)) {
                    var type = this.form.ProductEnquiryType.value;
                    this.setData(type, this.form.SearchSKU.value);
                }
            });

            this.form.DiamondDiscountPercent.changeSelect2(e => {
                var dd = this.form.DiamondDiscountPercent.value;

                if (dd != null && dd > 0) {
                    if (dd > 100) {
                        q.alert('', 'Discount should be between 1-100', true, 2999);
                        return;
                    }
                    var bomdetails = this.form.BOMDetails.getItems();
                    if (bomdetails != null && bomdetails.length > 0) {
                        for (var i = 0; i < bomdetails.length; i++)
                            if (bomdetails[i].ProductTypeId == 11) {
                                var amount = bomdetails[i].CalcOnId == 3 ? (bomdetails[i].Pieces * bomdetails[i].BomRate) : (bomdetails[i].Weight * bomdetails[i].BomRate);
                                bomdetails[i].BomAmount = amount - (amount * (dd / 100));
                            }
                        this.form.BOMDetails.setData(bomdetails);
                    }
                }
            });


        }
        setData(type: string, Code: string) {
            var mk = this.Markup;
            OMS.ProductMasterService.ProductEnquiry({ ProductCode: Code, EnquiryType: type },
                response => {
                    if (response.Entity != null) {
                        this.entity = response.Entity;
                        let product = response.Entity;

                        var data = ItemGridHelper.SetProduct(response.Entity, new Date(), 0, mk, 0, 0, true);
                        //data.UnitLabour = response.Entity.UnitLabour;
                        //data.LaborDetails = response.Entity.LaborDetails;
                        this.loadEntity(data);
                        if (product.ImageName != null && product.ImageName != "")
                            this.setProductImage(product.ImageName, this.form.ImageName);
                        if (product.Image1 != null && product.Image1 != "")
                            this.setProductImage(product.Image1, this.form.Image1);
                        if (product.Image2 != null && product.Image2 != "")
                            this.setProductImage(product.Image2, this.form.Image2);
                        if (product.Image3 != null && product.Image3 != "")
                            this.setProductImage(product.Image3, this.form.Image3);
                        if (type = 'SKU')
                            this.form.SearchSKU.value = Code;

                        this.form.ProductEnquiryType.value = type;
                    }
                    else {
                        q.Warning("No data found!", "", true);
                    }
                }, {
                async: false
            }

            );

            if (!isNaN(Q.parseInteger(this.form.ProductId.value))) {
                var HSN = [];
                var Amount = [];
                this.form.Rate.value = this.form.Rate.value + this.form.UnitLabour.value;
                HSN.push(this.form.TaxCode.value);
                Amount.push(this.form.Rate.value);
                var TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, new Date().toDateString(), false, 0);
                var self = this;
                TaxDetail.forEach(function (value) {
                    self.form.TaxAmount.value += value.TaxAmount;
                });

                this.form.TotalAmount.value = this.form.Rate.value + this.form.TaxAmount.value;
            }
        }

        protected onDialogOpen() {

            super.onDialogOpen();
            //this.dialogTitle
            //this.updateTitle();

            this.form.ProductEnquiryType.value = "SKU";

            q.showAndDisableField(this.form.ProductCode);

            q.showAndDisableField(this.form.ProductTypeId);
            q.showAndDisableField(this.form.ProductName);
            q.showAndDisableField(this.form.Rate);
            q.showAndDisableField(this.form.NetWeight);
            q.showAndDisableField(this.form.Weight);
            q.showAndDisableField(this.form.OtherPieces);
            q.showAndDisableField(this.form.OtherWeight);
            q.showAndDisableField(this.form.StoneWeight);
            q.showAndDisableField(this.form.StonePieces);
            q.showAndDisableField(this.form.DiamondWeight);
            q.showAndDisableField(this.form.DiamondPieces);
            q.showAndDisableField(this.form.TaxAmount);
            q.showAndDisableField(this.form.TotalAmount);
            q.showAndDisableField(this.form.HSN);
            q.showAndDisableField(this.form.TaxCode);
            q.hideField(this.form.IsDisabled);
            q.hideField(this.form.IsFeatured);
            q.hideField(this.form.IsNew);
            q.hideField(this.form.Purity);
            q.hideField(this.form.HasBom);
            q.hideField(this.form.IsDefaultSKU);
            q.hideField(this.form.SKU);
            q.hideField(this.form.Remarks);
            q.hideField(this.form.HSN);
            q.hideField(this.form.TaxCode);
            q.hideField(this.form.OtherPieces);
            q.hideField(this.form.OtherWeight);
            //this.dialogTitle = 'Product / Stock Inquiry';

            this.setReadOnly(true);
            q.showAndEnableField(this.form.ProductEnquiryType);
            q.showAndEnableField(this.form.SearchSKU);
            q.showAndEnableField(this.form.DiamondDiscountPercent);
            let searchusingsku = q.ToBool(TabAurous.GetConfigValue(1043));
            if (searchusingsku == true) {
                q.showAndEnableField(this.form.ProductEnquiryType);
                q.showAndEnableField(this.form.SearchSKU);
                q.showAndDisableField(this.form.ProductCode);
            } else if (searchusingsku == false) {
                q.hideField(this.form.ProductEnquiryType);
                q.hideField(this.form.SearchSKU);
                q.showAndEnableField(this.form.ProductCode);
            }
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            return [];
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            Swal.fire({
                title: 'Markup',
                input: 'number',
                inputPlaceholder: 'Enter Markup'
            }).then((result) => {
                if (isNaN(result.value))
                    this.Markup = 0;
                else
                    this.Markup = parseFloat(result.value);
            });



            this.element.find(".panel-titlebar-text").text("");
            //this.element.parent().find(".panel-titlebar-text").html("<b class='text-red'>Demo second</b>");
        }


        updateInterface() {
            super.updateInterface();
            //this.dialogTitle = 'Product / Stock Inquiry';
        }
        CalculateTotals() { }

        recalculateLabor() {
            let LAmount = 0; let Wst = 0;
            let pieces = this.form.Pieces.value
            let nwt = this.form.NetWeight.value;
            var wt = this.form.Weight.value;
            if (this.form.LaborDetails.getItems().length > 0) {

                var labor = this.form.LaborDetails.getItems();
                for (let l = 0; l < labor.length; l++) {
                    let item = labor[l];
                    switch (item.CalcOnId) {
                        case 61:
                            item.LabourAmount = item.MarkUp != null && item.MarkUp > 0 ? pieces * (item.LabourRate + item.MarkUp) : pieces * item.LabourRate;
                            break;
                        case 62:
                            item.Weight = nwt;
                            item.LabourAmount = item.MarkUp != null && item.MarkUp > 0 ? nwt * (item.LabourRate + item.MarkUp) : nwt * item.LabourRate;
                            break;
                        case 63:
                            item.Weight = wt;
                            item.LabourAmount = item.MarkUp != null && item.MarkUp > 0 ? wt * (item.LabourRate + item.MarkUp) : wt * item.LabourRate;
                            break;
                    }
                    labor[l] = item;
                }
                this.form.LaborDetails.setData(labor);
                for (let l of this.form.LaborDetails.getItems()) {

                    if (l.ProcessName == "Wastage")
                        Wst += l.WstPer;

                    LAmount += l.LabourAmount;
                }
            }
            this.form.UnitLabour.value = LAmount;

        }
        RecalculateMF(_product: any[]) {
            product = _product[0];
            var returnproduct: Retail.POSSalesItemsRow[] = ItemGridHelper.SetRetailItemGrid(_product, new Date(), product.PartyId, 1, 0, 0, 0);
            if (returnproduct.length > 0) {

                var product = returnproduct[0];


                var mk = this.Markup == null ? product.MF : this.Markup;
                var _Itemdetail = RateHelper.ReCalculateMarkUp(mk, product.MFAmount, product.BOMDetails, product.LaborDetails, product.Pieces, product.Weight, product.NetWeight
                    , product.FancyCharges, product.OtherCharges);
                product.BOMDetails = _Itemdetail.BOMDetails;
                product.LaborDetails = _Itemdetail.LaborDetails;
                product.UnitLabour = _Itemdetail.UnitLabour;
                product.UnitRate = _Itemdetail.UnitRate;
                product.UnitCost = _Itemdetail.UnitCost;
                product.GrossAmount = _Itemdetail.GrossAmount;
                var data = ItemGridHelper.SetProduct(product, new Date(), 0, mk, 0, 0, false);
                //data.UnitLabour = response.Entity.UnitLabour;
                //data.LaborDetails = response.Entity.LaborDetails;
                this.loadEntity(data);
                if (product.ImageName != null && product.ImageName != "") {
                    this.setProductImage(product.ImageName, this.form.ImageName)
                }
                this.form.MFAmount.value = product.MFAmount;
                this.form.Rate.value = product.UnitRate;
                this.form.TotalAmount.value = product.GrossAmount;
            }
        }
        setProductImage(image: string, editor: Serenity.ImageUploadEditor) {
            var imagename: Serenity.UploadedFile = {
                Filename: image,
                OriginalName: ""
            }
            editor.value = imagename;

        }
    }
}